import React from "react";
import { areaUnits, inventoryCategories, periods, spaceCategories } from "_constants";
import cx from "classnames";
import { Field } from "formik";
import { CurrencyField, UnitField } from "forms/fields";
import includes from "lodash/includes";
import PropTypes from "prop-types";
import DeleteItem from "rialto-icons/DeleteItem";

import IconButton from "components/IconButton";
import { Translate } from "utils";
import { isNumeric } from "utils/validation";

import formStyles from "forms/forms.css";
import styles from "./PriceField.css";

const { t } = new Translate("SpacesTable");

const unitsByCategory = (category) => {
  const { unit } = spaceCategories[category];

  return [
    ...areaUnits,
    ...(unit ? [unit] : []),
    ...(category === "office" ? ["floor"] : []),
    ...(includes(Object.keys(inventoryCategories), category) ? [] : ["space"]),
  ];
};

const InputDropdown = (
  { field: { name, value }, form: { setFieldValue } } // eslint-disable-line
) => (
  <div style={{ display: "flex" }}>
    <div>
      <input
        autoComplete="off"
        onChange={(e) => setFieldValue(name, { ...value, value: e.target.value })}
        type="number"
        value={(value || {}).value}
      />
    </div>
    <Field component={UnitField} name={`${name}.period`} units={Object.keys(periods)} />
  </div>
);

const PriceField = ({ field: { name }, hideMinContractLength, onRemove, spaceCategory }) => (
  <div className={styles.root}>
    <div className={styles.priceForm}>
      <div className={formStyles.field}>
        <label htmlFor="price">{t("headers.price")}</label>
        <Field component={CurrencyField} name={`${name}`} validate={isNumeric} />
      </div>

      <div className={styles.small}>{t("per")}</div>

      <div className={formStyles.field}>
        <label htmlFor="unit">{t("headers.sizeUnit")}</label>
        <Field
          component={UnitField}
          name={`${name}.unit`}
          type="text"
          units={unitsByCategory(spaceCategory)}
        />
      </div>

      <div className={styles.small}>{t("per")}</div>

      <div className={formStyles.field}>
        <label htmlFor="period">{t("headers.period")}</label>
        <Field
          component={UnitField}
          name={`${name}.period`}
          type="text"
          units={Object.keys(periods)}
        />
      </div>

      {!hideMinContractLength && (
        <div className={cx(formStyles.field, styles.bordered)}>
          <label htmlFor="minContractLength">{t("headers.minContractLength")}</label>
          <Field
            component={InputDropdown}
            name={`${name}.minContractLength`}
            type="text"
            units={Object.keys(periods)}
          />
        </div>
      )}
    </div>
    <IconButton icon={DeleteItem} onClick={onRemove} />
  </div>
);

PriceField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
  }),
  onRemove: PropTypes.func.isRequired,
  spaceCategory: PropTypes.string,
  hideMinContractLength: PropTypes.bool,
};

export default PriceField;
